<script lang="ts">
	import { t, locale } from '$lib/i18n';
	import PickList from './PickList.svelte';
	export let style: 'content' | 'phone' = 'content';
	export let question: any;
</script>

{#if question.type === 'singleLineText'}
	<label for="question-{question.order}" class:text-white={style === 'content'} class="text-sm"
		>{question.value}
	</label>
	<input
		name="question-{question.order}"
		id="question-{question.order}"
		class="w-full px-[1.5rem] py-2 my-2 text-[#000000] text-xs bg-[#fffff] border-none rounded-[0.4rem]"
		class:bg-slate-100={style === 'phone'}
		bind:value={question.userValue}
		type="text"
	/>
{/if}

{#if question.type === 'multiLineText'}
	<label for="question-{question.order}" class:text-white={style === 'content'} class="text-sm"
		>{question.value}
	</label>
	<textarea
		name="question-{question.order}"
		id="question-{question.order}"
		class="text-black w-full rounded-md px-4 py-2 my-2 text-xs bg-[#fffff]"
		bind:value={question.userValue}
		class:bg-slate-100={style === 'phone'}
	/>
{/if}

{#if question.type === 'pickList'}
	<label for="question-{question.order}" class:text-white={style === 'content'} class="text-sm">
		{question.value}
		<span class="mx-2">
			(max {question.maxSelectionCount}{#if question.maxSelectionCount > 1},
			{question.userValue.length}
			{$t('common.selected', { default: 'selected' })}{/if})
		</span>
	</label>
	<PickList
		questionOrder={question.order}
		bind:value={question.userValue}
		options={question.options}
		maxSelectionCount={question.maxSelectionCount}
		{style}
	/>
{/if}

{#if question.type === 'boolean'}
	<label
		for="question-{question.order}"
		class:text-white={style === 'content'}
		class="w-full text-sm"
		>{question.value}
		<input
			type="checkbox"
			name="question-{question.order}"
			id="question-{question.order}"
			placeholder={question.value}
			bind:checked={question.userValue}
			class="m-2 text-xs rounded-sm cursor-pointer text-sm"
		/>
	</label>
{/if}

{#if question.type === 'integer'}
	<label for="question-{question.order}" class:text-white={style === 'content'} class="text-sm"
		>{question.value}
	</label>
	<input
		type="number"
		name="question-{question.order}"
		id="question-{question.order}"
		bind:value={question.userValue}
		class="w-full px-[1.5rem] py-2 my-2 text-[#000000] text-xs bg-[#fffff] border-none rounded-[0.4rem]"
		class:bg-slate-100={style === 'phone'}
	/>
{/if}

{#if question.type === 'binary'}
	<div class="flex flex-col">
		<p class="mb-2 text-sm">{question.value}</p>
		<label
			for="question-{question.order}-yes"
			class:text-white={style === 'content'}
			class="w-full"
			>Yes
			<input
				value="yes"
				type="radio"
				name="question-{question.order}-yes"
				id="question-{question.order}-yes"
				placeholder={question.value}
				bind:group={question.userValue}
				class="m-2 text-xs rounded-sm cursor-pointer"
			/>
		</label>
		<label
			for="question-{question.order}-no"
			class:text-white={style === 'content'}
			class="w-full"
			>No
			<input
				value="no"
				type="radio"
				name="question-{question.order}-no"
				id="question-{question.order}-no"
				placeholder={question.value}
				bind:group={question.userValue}
				class="rounded-sm mx-3.5 m-2 cursor-pointer text-xs"
			/>
		</label>
	</div>
{/if}
